module.exports = {
  brief_valuation: { api: 'brief_valuation', human: 'Kurzbewertung' },
  detailed_appraisal: { api: 'detailed_appraisal', human: 'Detailliertes Gutachten' },
  digital_selfassessment: { api: 'digital_selfassessment', human: 'Digitale Selbstbewertung/Eigenbewertung' },
  purchaseDocument_invoice: { api: 'purchaseDocument_invoice', human: 'Kaufbeleg/Kaufrechnung' }
}
